
<template>
    <div class="sliderWrapperOuter" :class="hideRange">
        <span class="sliderTitle"><span style="cursor:pointer"> {{ valueName }} </span> </span> {{ rangeDescription }}
        <div class="row sliderWrapper">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <keep-alive>
                    <vue2-slider
                    ref="slider"
                    :real-time="true"
                    :show="true"
                    :speed="0"
                    :value="currentValue"
                    :min="round(min)"
                    tooltip="none"
                    :max="round(max)"
                    :height="10"
                    :dotSize="26"
                    v-bind="options"
                    :interval="interval"
                    :contained="true"
                    @click="startSlide"
                    @drag-start="startSlide"
                    @change="changed"
                    @drag-end="endSlide"/>
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Slider from 'vue-slider-component';

export default {
    props: ['id', 'title', 'value', 'min', 'max', 'labels', 'interval', 'prefix', 'suffix', 'roundTo', 'valueName', 'index', 'notAbsolute'],
    components: {
        vue2Slider,
    },
    data () {
        return {
            currentValue: [0, 1],
            dragging: false,
            options: {},
        };
    },
    mounted () {
        this.currentValue = [this.round(this.min), this.round(this.max)];
        this.changed(this.currentValue);
        this.width = this.width === undefined ? this.$refs.slider.$el.offsetWidth : this.width;
    },
    methods: {
        // called when slider has been pressed on
        startSlide (event) {
            this.dragging = true;
        },
        // called when slider has had mouse button depressed
        endSlide (event) {
            this.dragging = false;
            this.$emit('input', this.currentValue);
        },
        // called when the slider is moving
        changed (val) {
            this.currentValue = val;
            if (!this.dragging) {
                this.$emit('input', val);
            }
        },
        setColours () {
            this.options.sliderStyle = [{ backgroundColor: this.themeColours[0], borderRadius: '13px', top: '-8px' }, { backgroundColor: this.themeColours[1], borderRadius: '13px', top: '-8px' }];
            this.options.processStyle = { backgroundImage: `-webkit-linear-gradient(left, ${this.themeColours[0]}, ${this.themeColours[1]})` };
        },
        round(number) {
            let dp = this.roundTo;
            return Math.round(number * (10 ** dp)) / (10 ** dp);
        }
    },
    computed: {
        rangeDescription () {
            const isOnMin = this.currentValue[0] === this.round(this.min);
            const isOnMax = this.currentValue[1] === this.round(this.max);
            if (isOnMin && isOnMax) return 'full range';
            let displayVal1 = this.currentValue[0];
            let displayVal2 = this.currentValue[1];
			let displaySuffix = this.suffix;

            if (typeof (this.labels) === 'undefined' || this.labels.length === 0) {
                if (this.valueName === 'Length of track record') {
                    displaySuffix = ' yrs';
				} else if  (this.valueName === 'Standard deviation (% pa)' || this.valueName === 'Return (% - pa over 1y)' || this.valueName === 'Max drawdown') {
					displayVal1 = Math.round(this.currentValue[0] * 10)  / 10;
                    displayVal2 = Math.round(this.currentValue[1] * 10)  / 10;
				} else if (this.valueName === 'AUM') {
                    displaySuffix = 'bn';
                    displayVal1 = (this.currentValue[0] / 1000);
                    displayVal2 = (this.currentValue[1] / 1000);
				}

                if (isOnMax) {
                    return ` > ${this.prefix}${displayVal1.toLocaleString()}${displaySuffix}`;
                } if (isOnMin) {
                    return ` < ${this.prefix}${displayVal2.toLocaleString()}${displaySuffix}`;
                } if (this.valueName === 'Length of track record') {
                    return `from ${this.prefix}${displayVal1.toLocaleString()} to ${this.prefix}${displayVal2.toLocaleString()}${displaySuffix}`;
				}

                return `from ${this.prefix}${displayVal1.toLocaleString()}${displaySuffix} to ${this.prefix}${displayVal2.toLocaleString()}${displaySuffix}`;
            }
            return '';
        },
        hideRange () {
            return !this.showList && this.$store.state.ui.dropdownSelected ? 'hideRange' : '';
        },
    },
    watch: {
        id () {
            this.currentValue = [this.round(this.min), this.round(this.max)];
        },
        value () {
            if (this.round(this.currentValue[0]) !== this.round(this.value[0]) || this.round(this.currentValue[1]) !== this.round(this.value[1])) {
                this.currentValue = [this.round(this.value[0]), this.round(this.value[1])];
            }
        },
        themeColours: {
            handler () {
                this.setColours();
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.sliderTitle {
    color: #002c5c;
    font-size: 18px;
    font-weight: 700;
    margin-right: 10px;
}
.sliderWrapper {
    margin-bottom: 10px;
}
.sliderWrapperOuter {
    width: 100%;
}
.hideRange {
    display: none;
}
@media (max-width: 1536px) {
    .sliderTitle {
        font-size: 14px;
    }
    .sliderWrapper {
        margin-bottom: 0px;
        .vue-slider-wrap {
            margin-top: 0px;
        }
    }
}
.vue-slider-wrap {
    margin-top: 0px;
}
</style>
<style lang="scss">
.vue-slider-process, .vue-slider-dot {
    // z-index: auto!important;
}
</style>
